import BidThemeContext from "@/contexts/BidThemeContext";
import { useContext } from "react";

export default function MainLoading() {
  const bidThemeContext = useContext(BidThemeContext);

  return (
    <div className="h-full min-h-96 w-full flex items-center justify-center">
      <img
        height="192"
        width="192"
        className="animate-pulse"
        src={bidThemeContext.logo}
        alt="Carregando..."
      />
    </div>
  );
}
